/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import ShortcutIcon from '@atlaskit/icon/core/migration/link-external--shortcut';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { analyticsAttributes, getItemAnalyticsContext, NavigationAnalyticsContext, withAnalyticsContextData } from '../../common/utils/analytics';
import { FadeIn } from './fade-in';
import ItemLink from './item-link';
import { AnalyticsItemType } from '../../types';
import Heading from '@atlaskit/heading';
var sectionContainerStyles = css({
  padding: "var(--ds-space-075, 6px)".concat(" 0")
});
var secondarySectionTitleBaseStyles = xcss({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
  marginTop: 'space.200',
  marginLeft: 'space.100',
  color: 'color.text.subtle',
  font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
  fontWeight: "var(--ds-font-weight-bold, 700)"
});
var secondarySectionTitleStandaloneStyles = xcss({
  marginBottom: 'space.050'
});
var sectionChildrenWrapperStyles = css({
  listStyleType: 'none',
  padding: 0,
  margin: 0
});
export var SectionContainerTitle = function SectionContainerTitle(_ref) {
  var title = _ref.title;
  // Helper function to capitalize each word in a string
  return jsx(Heading, {
    as: "h3",
    size: "xxsmall"
  }, jsx(Box, {
    xcss: [secondarySectionTitleBaseStyles, secondarySectionTitleStandaloneStyles]
  }, title));
};
var SectionContainerComponent = function SectionContainerComponent(_ref2) {
  var title = _ref2.title,
    titleLink = _ref2.titleLink,
    children = _ref2.children,
    actionSubject = _ref2.actionSubject,
    sectionId = _ref2.sectionId,
    sectionRole = _ref2.sectionRole,
    ariaLabel = _ref2.ariaLabel;
  return React.Children.toArray(children).some(Boolean) ? jsx("section", {
    css: sectionContainerStyles,
    "data-testid": "".concat(sectionId, "__section"),
    role: sectionRole,
    "aria-label": ariaLabel
  }, jsx(FadeIn, null, title && jsx(SectionContainerTitle, {
    title: title
  }), titleLink && jsx(TitleLink, {
    titleLink: titleLink,
    actionSubject: actionSubject
  })), jsx("ul", {
    css: sectionChildrenWrapperStyles
  }, children)) : null;
};
var TitleLink = function TitleLink(_ref3) {
  var titleLink = _ref3.titleLink,
    actionSubject = _ref3.actionSubject;
  return jsx(NavigationAnalyticsContext, {
    key: titleLink.key,
    data: getItemAnalyticsContext(0, titleLink.key, AnalyticsItemType.PRODUCT, titleLink.productType)
  }, jsx(ItemLink, {
    href: titleLink.href,
    iconAfter: jsx(ShortcutIcon, {
      LEGACY_size: "small",
      color: "currentColor",
      label: ""
    }),
    label: titleLink.label,
    testId: "section-title__link",
    actionSubject: actionSubject,
    ariaLabel: titleLink.ariaLabel
  }));
};
export var SectionContainer = withAnalyticsContextData(function (props) {
  return analyticsAttributes({
    group: props.sectionId,
    groupItemsCount: React.Children.toArray(props.children).filter(function (child) {
      return /*#__PURE__*/React.isValidElement(child);
    }).length
  });
})(SectionContainerComponent);